import { newApi } from './api.instance';
import { objToQueryWithoutCookies } from '../../helpers/common';
import { Pagination } from './api.types';
import { GenericAbortSignal } from 'axios';
import { CompoundSummaryDto } from '../../features/map/dtos';
import { DeveloperLaunchDto } from '../dtos/developers/developer-launch.dto';
import { CompoundLaunchDto } from '../dtos/compounds/compound-launch.dto';
import { Compound } from '../types/entity';

export class CompoundsApis {
  public static autocomplete = async (
    language?: string,
    searchTerm?: string,
    options?: {
      signal?: GenericAbortSignal;
      areasIds?: number[];
      by?: 'NAWY_UNLOCKED';
    }
  ) => {
    let query: { [key: string]: string | number | number[] } = {};
    if (searchTerm && searchTerm !== '') {
      query.searchTerm = searchTerm;
    }
    if (options?.by) {
      query.by = options.by;
    }
    if (options?.areasIds && options.areasIds.length > 0) {
      query.areasIds = options.areasIds;
    }
    return newApi({ ssrLocale: language })
      .get(`/v1/compounds/autocomplete?${objToQueryWithoutCookies(query)}`, {
        signal: options?.signal
      })
      .then(({ data }) => data);
  };

  public static getPopularCompounds = async (
    pagination: Pagination,
    language?: string
  ) => {
    return newApi({ ssrLocale: language })
      .get(
        `v1/compounds/top?page=${pagination.page}&pageSize=${pagination.pageSize}`
      )
      .then(({ data }) => data);
  };

  public static async getCompoundSummary(
    id: number,
    params?: any,
    language?: string,
    options?: { signal?: GenericAbortSignal }
  ): Promise<CompoundSummaryDto> {
    return newApi({ ssrLocale: language })
      .get(`/v1/compounds/${id}/summary`, { params, signal: options?.signal })
      .then(({ data }) => data);
  }

  public static getCompoundLaunches = async (
    id: number,
    language?: string
  ): Promise<CompoundLaunchDto[]> => {
    return newApi({ ssrLocale: language })
      .get(`/v1/compounds/${id}/launches`)
      .then(({ data }) => data);
  };

  public static async getCompound(
    id: number,
    params?: any,
    language?: string
  ): Promise<Compound> {
    return newApi({ ssrLocale: language })
      .get(`/v1/compounds/${id}`, { params })
      .then(({ data }) => data);
  }
}
